import request from "@/utils/axios-v2";
import axios from "axios";
import { getStorage } from '@/utils/storage'
const baseURL = process.env.VUE_APP_URL;

/**
 * 
 * @param {*} params
 * @returns
 */
export function getReport(params) {
  return request({
    url: "/fleet/ifta/report/query",
    method: "post",
    params,
    headers: {
      "portal-token": true,
    },
  });
}

/**
 * 
 * @param {*} params
 * @returns
 */
export function getBaseReport(params, data) {
  return request({
    url: "/fleet/ifta/base/report/get",
    method: "post",
    params,
    data,
    headers: {
      "portal-token": true,
      "Content-Type": "application/json",
    },
  });
}

/**
 * 
 * @param {*} params
 * @returns
 */
export function downReport(params) {
  const headers = {}
  if (getStorage('x-portal-token') === 'yes') {
    headers['x-portal-token'] = getStorage()
  } else {
    headers['portal-token'] = getStorage()
  }
  return axios({
    url: "/fleet/ifta/report/download",
    method: "post",
    params,
    headers,
    // headers: {
    //   "portal-token": true,
    //   // "Accept": "application/pdf"
    // },
    responseType: "blob",
    baseURL,
  });
}

/**
 * 
 * @returns 
 */
export function getTruckList() {
  return request({
    url: "/fleet/ifta/truck_list/get",
    method: "get",
    headers: {
      "portal-token": true
    },
  })
}

/**
 * @returns 
 */
export function saveReport(params) {
  return request({
    url: "/fleet/ifta/save_report",
    method: "get",
    params,
    headers: {
      "portal-token": true
    }
  })
}

/**
 * @param {*} params 
 * @returns 
 */
 export function getBaseReportTruck(params) {
  return request({
    url: "/fleet/ifta/base/report/truck/get",
    method: "get",
    params,
    headers: {
      "portal-token": true
    }
  })
}